import { render, staticRenderFns } from "./MerchantOnBoardingDetails.vue?vue&type=template&id=2470ddf8"
import script from "./MerchantOnBoardingDetails.vue?vue&type=script&lang=js"
export * from "./MerchantOnBoardingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports